import { SetupScreen } from "./SetupScreen";

/**
 * Setup flow shell for the setup_pending onboarding step.
 * Renders on /home when onboardingStep === "setup_pending".
 */
export const SetupPlaceholder = () => {
  return <SetupScreen />;
};
